import _defineProperty from '@babel/runtime/helpers/defineProperty';
import { inPixels, px2rem } from '../utils/helpers/style.js';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), true).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var tabsAttributesNative = {
  color: 'primary',
  border: 'border.light',
  background: 'background',
  textColor: 'text',
  transparent: {
    textColor: 'text.desaturated',
    borderColor: 'border.desaturated'
  },
  height: 56,
  fontSize: {
    "default": 'M',
    XS: 16,
    S: 18,
    L: 23,
    M: 20
  },
  navButton: {
    paddingLeftRight: 32,
    selected: {
      border: {
        width: 4
      }
    },
    unselected: {
      textColor: 'text.secondary',
      border: {
        width: 0
      }
    }
  }
};
var tabsThemeNative = _objectSpread(_objectSpread({}, tabsAttributesNative), {}, {
  variants: {
    condensed: {
      fontSize: {
        "default": 'XS'
      },
      height: 40,
      navButton: {
        paddingLeftRight: 16,
        selected: {
          border: {
            width: 2
          }
        }
      }
    }
  }
});
var tabsAttributesWeb = {
  color: 'primary',
  background: 'background',
  /**
   * Gap between the tabs
   */
  gap: 0,
  textColor: 'text',
  borders: {
    radius: 'borders.radius',
    color: 'border.light'
  },
  /**
   * Tab button heights
   */
  height: {
    /**
     * Below breakpoint s
     */
    "default": inPixels(48),
    /**
     * At breakpoint s and above
     */
    s: inPixels(56)
  },
  fontSize: {
    "default": 'M',
    base: px2rem(18),
    XS: 16,
    S: 18,
    M: 20,
    L: 23
  },
  inactive: {
    background: 'transparent'
  },
  active: {
    mode: 'underline',
    focusHighlight: 'lighten'
  },
  selectedBorderWidth: px2rem(4)
};
var tabsThemeWeb = _objectSpread(_objectSpread({}, tabsAttributesWeb), {}, {
  variants: {
    condensed: {
      fontSize: {
        base: px2rem(16),
        "default": 'XS'
      },
      height: {
        /**
         * Below breakpoint s
         */
        "default": px2rem(40),
        /**
         * At breakpoint s and above
         */
        s: px2rem(40)
      },
      selectedBorderWidth: px2rem(2)
    }
  }
});

export { tabsAttributesNative, tabsAttributesWeb, tabsThemeNative, tabsThemeWeb };
